module.exports = __webpack_public_path__ + "img/status_map_security_measures_to_systems.b95c29b1.gif";